<template>
    <div>
        <b-modal :id="modalId"
                 modal-class="modal-confirm"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-head"
                    v-if="title">
                    <p id="confirm_title" v-html="title"></p>
                </div>
                <div class="modal-base-body"
                    v-if="message">
                    <p id="confirm_msg" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="confirm_btn_row">
                        <div class="confirm-modal-btn">
                            <PrimaryButton
                                btnId="confirm_confirm_btn"
                                :btnMsg="btnConfirm"
                                @clickButton="clickConfirm()" />
                        </div>
                        <div class="confirm-modal-btn">
                            <SecondaryButton
                                btnId="confirm_cancel_btn"
                                :btnMsg="btnCancel"
                                @clickButton="clickCancel()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// helper
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
// components
import SecondaryButton from "@/components/Button/SecondaryButton.vue";
import PrimaryButton from "@/components/Button/PrimaryButton.vue";
/**
 * @property {ConfirmModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ConfirmModal",
    components: {
        SecondaryButton,
        PrimaryButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),

            title: '',
            message: '',
            btnConfirm: '',
            btnCancel: '',
            tag: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickConfirm: function () {
            this.controller.cbConfirm.sendCallback({ tag: this.tag });
            this.$nextTick(() => {
                this.hide();
            });
        },
        clickCancel: function() {
            this.controller.cbCancel.sendCallback({ tag: this.tag });
            this.$nextTick(() => {
                this.hide();
            });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnConfirm = config.btnConfirm;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;

            if (Util.isEmptyStr(config.title))
                this.title = this.lbl.default.error_title;

            if (Util.isEmptyStr(config.btnConfirm))
                this.btnConfirm = this.lbl.default.confirm;

            if (Util.isEmptyStr(config.btnCancel))
                this.btnCancel = this.lbl.default.cancel;

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        }
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

#confirm_title {
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    color: $color-gray;
}

#confirm_msg {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: $color-gray;
}

#confirm_btn_row {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-confirm {
    @extend %modal-base;

    .modal-dialog {
        max-width: 300px;
    
    }

    .modal-body {
        padding: 30px 20px;
    }
}
</style>
